<div class="appointment-card p-3 p-md-4">
  <div class="d-flex align-items-start gap-3 flex-wrap flex-md-nowrap">
    <!-- Avatar Initials / Image -->
    <div class="avatar-wrapper flex-shrink-0">
      <div class="patient-avatar-circle">
        {{ booking.patient.firstName.charAt(0) }}{{ booking.patient.lastName.charAt(0) }}
      </div>
    </div>

    <!-- Details -->
    <div class="flex-grow-1 min-w-0">
      <!-- Top header row -->
      <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <span class="status-pill" [ngClass]="statusClass">
            <i class="bi bi-circle-fill" style="font-size: 0.5rem"></i>
            {{ booking.status }}
          </span>
          <span class="time-badge">
            <i class="bi bi-clock me-1 text-primary"></i>{{ booking.bookingSlot.slotTime }}
          </span>
          <span class="date-badge text-muted small">
            <i class="bi bi-calendar-event me-1"></i
            >{{ booking.bookingSlot.slotDate | date: 'dd MMM yyyy' }}
          </span>
        </div>

        <!-- Action dropdown -->
        <div class="dropdown">
          <button
            class="btn btn-sm btn-light border dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-gear me-1 text-primary"></i>Manage
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <a class="dropdown-item" (click)="onView()">
                <i class="bi bi-eye me-2 text-primary"></i>View Details
              </a>
            </li>
            <li *ngIf="booking.status === AppointmentStatus.Confirmed">
              <a class="dropdown-item" (click)="onStart()">
                <i class="bi bi-play-circle me-2 text-success"></i>Start Consultation
              </a>
            </li>
            <li *ngIf="booking.status === AppointmentStatus.Ongoing && canComplete">
              <a class="dropdown-item" (click)="onComplete()">
                <i class="bi bi-check2-all me-2 text-success"></i>Mark as Complete
              </a>
            </li>
            <li
              *ngIf="
                booking.status === AppointmentStatus.Confirmed ||
                booking.status === AppointmentStatus.Pending
              "
            >
              <a class="dropdown-item" (click)="onNoShow()">
                <i class="bi bi-person-slash me-2 text-warning"></i>Mark No Show
              </a>
            </li>
            <li
              *ngIf="
                booking.status === AppointmentStatus.Pending ||
                booking.status === AppointmentStatus.Confirmed
              "
            >
              <hr class="dropdown-divider" />
              <a class="dropdown-item text-danger" (click)="onCancel()">
                <i class="bi bi-x-circle me-2"></i>Cancel Appointment
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Patient Name & Details -->
      <h4 class="patient-name mb-2">
        {{ booking.patient.firstName }} {{ booking.patient.lastName }}
      </h4>

      <div class="detail-matrix mb-2">
        <div class="detail-chip">
          <span class="detail-chip__label">Patient Details</span>
          <span class="detail-chip__value"
            >{{ booking.patient.dateOfBirth ?? '' | age }} yrs &bull;
            {{ booking.patient.gender || '—' }}</span
          >
        </div>

        <div class="detail-chip">
          <span class="detail-chip__label">Practitioner</span>
          <span class="detail-chip__value text-primary">
            {{ booking.doctor.user.title }} {{ booking.doctor.user.firstName }}
            {{ booking.doctor.user.lastName }}
          </span>
        </div>

        @if (booking.reasonForVisit) {
          <div class="detail-chip">
            <span class="detail-chip__label">Reason for Visit</span>
            <span class="detail-chip__value text-truncate">{{ booking.reasonForVisit }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
